// @flow

import { createStore, applyMiddleware, compose } from 'redux';
import config from './global/config';
import middlewares from './global/middlewares';
import reducer from './rootReducer';
import { translations } from './translations';
import { i18nActions } from 'redux-react-i18n';


// Check for dev env, if false hide extensions like redux
const { isDev, isBrowser } = config;
const devtools = isDev && isBrowser && window.devToolsExtension
  ? window.devToolsExtension
  : () => (fn) => fn;


console.warn = function () { };
console.error = function () { };



const dictionaries = translations;

const languages = [
  {
    code: 'en-US',
    name: 'English (USA)'
  }
];

const configureStore = (initialState = {}, services = {}) => {
  const enhancers = [
    applyMiddleware(
      ...middlewares,
    ),
    devtools()
  ];

  const store = createStore(reducer, initialState, compose(...enhancers));
  store.dispatch(i18nActions.setDictionaries(dictionaries));
  store.dispatch(i18nActions.setLanguages(languages));
  store.dispatch(i18nActions.setCurrentLanguage('en-US'));
  return store;
};

export default configureStore;
